<template>
	<div :class="$style.notification">
		<BaseTooltip v-if="notification.date" position="right" :content="date">
			<TimeAgo
				:class="[$style['color'], $style['color--grey']]"
				:timestamp="timestamp"
			/>
		</BaseTooltip>
		<p :class="$style['notification__title']" class="notification__title">
			{{
				$t(`notifications.types.bulk-update.${notification.operationType}.title`)
			}}
		</p>
		<p :class="$style['notification__notice']">
			{{ $t("common.fields.department") }}:
			<RouterLink
				:to="{ name: 'Dashboard:Department', params: { id: department.id } }"
			>
				{{ department.name }}
			</RouterLink>
		</p>
		<p :class="$style['notification__notice']">
			{{ $t("notifications.types.bulk-update.finished-updating") }}:
			<strong :class="$style['color--success']">{{
				notification.finishedUpdating
			}}</strong>
		</p>
		<p :class="$style['notification__notice']">
			{{ $t("notifications.types.bulk-update.failed-updating") }}:
			<strong :class="$style['color--danger']">{{
				notification.failedUpdating
			}}</strong>
		</p>
	</div>
</template>

<script>
// import gql from 'graphql-tag'
import { faLongArrowRight } from '@fortawesome/pro-light-svg-icons'
import moment from '@/packages/moment'
import TimeAgo from '@/components/Essentials/TimeAgo'
export default {
	name: 'BulkUpdateNotification',
	components: {
		TimeAgo
	},
	props: {
		notification: {
			type: Object,
			required: true
		}
	},
	data () {
		return {
			icons: {
				faLongArrowRight
			}
		}
	},
	computed: {

		department () {
			return this.$auth().departments.find(department => department.id === this.notification.departmentId)
		},

		date () {
			if (this.notification.date) {

				return moment(this.notification.date).format('LLLL')
			}
			return null
		},
		timestamp () {
			if (this.notification.date) {

				return new Date(this.notification.date).getTime()
			}
			return null
		}
	},
	methods: {
	}
}
</script>

<style lang="scss" module>


	.color {
		font-size: 12px;

		&--grey {
		color: getColor(caption);
		}

		&--primary {
			color: getColor(tertiary);
		}

		&--success {
			color: getColor(success);
		}

		&--danger {
			color: getColor(danger);
		}
	}

	.notification {
		&__title {
			margin: 0;
			margin-top: 5px;
			margin-bottom: 5px;
			font-size: 16px;
		}

		&__notice {
			margin: 0;
			margin-bottom: 5px;
			font-size: 14px;
			// color: getColor(helper-text);
		}
	}
</style>
